export default "__VITE_ASSET__BZHCmiZ0__"